// What the rider's phone does once MyTownly has raised the Intertown SOS (triggerIntertownSos):
// who gets the live link and how. Kept free of React, Firebase and the browser so it can be
// tested on its own; IntertownTripScreen carries the plan out.
//
// It is the same plan as a local ride's SOS sheet (components/SosSheet.js alertContacts): WhatsApp
// opens for the first emergency contact and an SMS is prepared for each of the others, so every one
// of them has the link ready to send. With no saved contact the rider picks who to send it to in WhatsApp.
// These only open composers: the rider still presses Send, and the app can never confirm that.

/** The server returns the caller's saved contacts; only ones with a usable 10-digit number count. */
export const usableContacts = (contacts) => (Array.isArray(contacts) ? contacts : [])
  .map((c) => ({ name: String(c?.name || ''), phone: String(c?.phone || '').replace(/\D/g, '').slice(-10) }))
  .filter((c) => c.phone.length === 10);

/**
 * The messages to send, in order: `via` is 'whatsapp' or 'sms', `phone` is '' when the rider should
 * pick the person. Nothing to send without an https link.
 */
export function planSosShare({ contacts, trackUrl, t, city }) {
  if (typeof trackUrl !== 'string' || !/^https:\/\/\S+$/.test(trackUrl)) return [];
  const people = usableContacts(contacts);
  if (!people.length) {
    return [{ via: 'whatsapp', phone: '', text: t('sos.directShareMsg', { city, track: trackUrl }) }];
  }
  const text = t('sos.alertMsg', { city, track: trackUrl });
  return people.map((person, i) => ({ via: i === 0 ? 'whatsapp' : 'sms', phone: person.phone, text }));
}

/** A share composer cannot confirm delivery; only the server alert is confirmed. */
export function sosToast(plan) {
  return { key: plan.length ? 'intertown.trip.alertShareReady' : 'intertown.trip.alertTeamDone', vars: {} };
}
